// import React from "react";
// import "./service.css";

// import BrainstormIcon from "../assets/brainstorm.svg";
// import ElectronicsIcon from "../assets/electronics.svg";
// import MobileDevIcon from "../assets/mobiledev.svg";
// import WebDevIcon from "../assets/mobiledev.svg";
// import CloudTechIcon from "../assets/cloud-tech.svg";
// import MarketingIcon from "../assets/marketing.svg";
// import ContainerImage from "../assets/Container.svg";

// const services = [
//   {
//     icon: BrainstormIcon,
//     title: "Ideation and Brainstorming",
//     description:
//       "We love to discuss ideas and tune them to create better from the end product or services.",
//   },
//   {
//     icon: ElectronicsIcon,
//     title: "Electronics R&D",
//     description: "Electronics & IoT Prototyping and Product Development.",
//   },
//   {
//     icon: MobileDevIcon,
//     title: "Mobile App Development",
//     description:
//       "Expertise in both Android and iOS Apps with Flutter Framework.",
//   },
//   {
//     icon: WebDevIcon,
//     title: "Website Development",
//     description:
//       "Sublime is easy to use and totally customizable to your business needs.",
//   },
//   {
//     icon: CloudTechIcon,
//     title: "Cloud Technology",
//     description:
//       "Sublime is easy to use and totally customizable to your business needs.",
//   },
//   {
//     icon: MarketingIcon,
//     title: "Content Creation & Marketing",
//     description:
//       "Sublime is easy to use and totally customizable to your business needs.",
//   },
// ];

// const Services = () => {
//   return (
//     <section id="services" className="services-section">
//       {/* Left Content - Heading */}
//       <div className="services-text">
//         <p className="section-label">Our Service Offering</p>
//         <h2 className="services-title">
//           Provide powerful <br /> solutions at all times.
//         </h2>
//       </div>

//       {/* Right Side: Container Image + Text */}
//       <div className="container-wrapper">
        
//         <div className="container-text">
//           <img src={ContainerImage} alt="Container" className="container-image" />
//           <p>Supercharge your idea and optimize your workflow with</p>
//           <p>Sublime. Our intuitive interface and robust features for you</p>
//         </div>
        
//       </div>

//       {/* Service Cards */}
//       <div className="services-grid">
//         {services.map((service, index) => (
//           <div className="service-card" key={index}>
//             <img
//               src={service.icon}
//               alt={service.title}
//               className="service-icon"
//             />
//             <h3 className="service-title">{service.title}</h3>
//             <p className="service-description">{service.description}</p>
//             <button className="service-button"></button>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default Services;

import React, { useState } from "react";
import "./service.css";

import BrainstormIcon from "../assets/brainstorm.svg";
import ElectronicsIcon from "../assets/electronics.svg";
import MobileDevIcon from "../assets/mobiledev.svg";
import WebDevIcon from "../assets/mobiledev.svg";
import CloudTechIcon from "../assets/cloud-tech.svg";
import MarketingIcon from "../assets/marketing.svg";
import ContainerImage from "../assets/Container.svg";

import Booking from "../Components-2/Booking";
import ModalWrapper from "../Components-2/ModalWrapper";

const services = [
  {
    icon: BrainstormIcon,
    title: "Ideation and Brainstorming",
    description: "We love to discuss ideas and tune them to create better from the end product or services.",
  },
  {
    icon: ElectronicsIcon,
    title: "Electronics R&D",
    description: "Electronics & IoT Prototyping and Product Development.",
  },
  {
    icon: MobileDevIcon,
    title: "Mobile App Development",
    description: "Expertise in both Android and iOS Apps with Flutter Framework.",
  },
  {
    icon: WebDevIcon,
    title: "Website Development",
    description: "Custom-crafted websites that adapt to your business and scale with your vision.",
  },
  {
    icon: CloudTechIcon,
    title: "Cloud Technology",
    description: "Flexible, secure, and scalable cloud solutions built for modern infrastructure.",
  },
  {
    icon: MarketingIcon,
    title: "Content Creation & Marketing",
    description: "Engaging content and smart strategies that amplify your brand’s voice.",
  },
];

const Services = () => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedPurpose, setSelectedPurpose] = useState("");

  const handleOpenForm = (purpose) => {
    setSelectedPurpose(purpose);
    setOpenModal(true);
  };

  return (
    <section id="services" className="services-section">
      {/* Left Content - Heading */}
      <div className="services-text">
        <p className="section-label">Our Service Offering</p>
        <h2 className="services-title">
          Provide powerful <br /> solutions at all times.
        </h2>
      </div>

      {/* Right Side: Container Image + Text */}
      <div className="container-wrapper">
        <div className="container-text">
          <img src={ContainerImage} alt="Container" className="container-image" />
          <p>Supercharge your idea and optimize your workflow with Rosette Technologies. Our intuitive interface and robust features for you</p>
        </div>
      </div>

      {/* Service Cards */}
      <div className="services-grid">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <img src={service.icon} alt={service.title} className="service-icon" />
            <h3 className="service-title">{service.title}</h3>
            <p className="service-description">{service.description}</p>
            <button
              className="service-button"
              onClick={() => handleOpenForm(service.title)}
            >
              
            </button>
          </div>
        ))}
      </div>

      {/* ✅ Booking Modal with prefilled purpose */}
      <ModalWrapper show={openModal} onClose={() => setOpenModal(false)}>
        <Booking prefilledPurpose={selectedPurpose} />
      </ModalWrapper>
    </section>
  );
};

export default Services;

